<!--
 * @Author: zhujun zhujun@yhb-work.com
 * @Date: 2024-09-30 10:41:46
 * @LastEditors: luoyuhao luoyuhao@yhb-work.com
 * @LastEditTime: 2026-04-01 14:51:26
 * @FilePath: \YHB_H5\src\pages\jcc\agreemnet.vue
 * @Description: 聚充充用户协议与隐私政策
-->
<template>
  <div class="content">
    <div v-html="content"></div>
  </div>
</template>
<script>
  import { getAgreementByType } from '@/api/jcc'
  import { Toast } from 'vant';
  export default {
    data() {
      return {
        title: '',
        content: '',
        agreementList: [
          { id: 91, title: "聚充充用户服务协议" }, //（代理端）
          { id: 92, title: "聚充充用户隐私协议" }, //（代理端）
          { id: 93, title: "聚充充用户隐私协议" }, //（用户端）
          { id: 94, title: "聚充充用户服务协议" }, //（用户端）
          { id: 95, title: "聚充充平台使用规则" }, //（用户端）
          { id: 97, title: "聚充充充电功率说明" }, //（用户端）
          { id: 100, title: "User Agreement" }, // 智充用户协议（用户端）
          { id: 101, title: "Privacy Policy" }, // 智充隐私政策（用户端）
          { id: 102, title: "ZapCharge Usage Rules" }, // 智充使用规则（英文）
          { id: 103, title: "ZapCharge使用規則" }, // 智充使用规则（繁体）
          { id: 104, title: "Charging Power Description" }, // 智充充电功率说明（英文
          { id: 105, title: "充電功率說明" }, // 智充充电功率说明（繁体）
          { id: 106, title: "ZapCharge使用规则" }, // 智充平台使用规则（中文）
          { id: 107, title: "用户协议" }, // 智充用户协议（简中）
          { id: 108, title: "隐私协议" }, // 智充隐私协议（简中）
          { id: 109, title: "" }, // 智充充值说明（中文）
          { id: 110, title: "" }, // 智充充值说明（繁体
          { id: 111, title: "" }, // 智充充值说明（英文）
          { id: 112, title: "ZapCharge充电功率说明" }, // 智充充电功率说明（中文）
          { id: 113, title: "即得电用户隐私协议" }, // 即得电用户隐私协议
          { id: 114, title: "即得电用户服务协议" }, // 即得电用户服务协议
          { id: 115, title: "即得电平台使用规则" }, // 即得电平台使用规则
          { id: 119, title: "聚快选隐私协议" }, // 聚快选隐私协议、聚快选用户隐私政策
          { id: 120, title: "聚快选服务协议" }, // 聚快选服务协议
          { id: 121, title: "聚快选用户服务协议" }, // 聚快选助手用户服务协议
          { id: 123, title: "聚快选用户服务协议" }, // 聚快选助手使用规则
          { id: 124, title: "车载闪充用户隐私协议" }, // 聚快选助手使用规则
          { id: 125, title: "车载闪充用户服务协议" }, // 聚快选助手使用规则
        ]
      }
    },
    mounted() {
      let typeId = this.$route.query.typeId
      if (this.agreementList.find(item => item.id == typeId) || typeId) {
        this.getInformation(typeId)
      } else {
        alert('未查到相关文件')
      }
    },
    methods: {
      getInformation(typeId) {
        getAgreementByType(typeId).then(res => {
          if (res.code != 200) {

            Toast({
              message: res.msg,
              duration: 3000
            });
            return;
          }
          this.title = res.data.title;
          document.title = res.data.title
          this.content = res.data.content
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .content {
    padding: 30px;
    line-height: 1.8;

    pre {
      white-space: pre-line;
    }
  }
</style>